import React from 'react';

import { SelectItem } from "#app/components/calendar/styles";
import { useTaskTypesIcons } from "#app/components/relations/Contacts/hooks/useTaskTypesIcons";
import { Body } from "#app/components/texts/Typography";

interface SelectTypeProps {
    id?: string;
    typeId: number;
    setType: (id: number) => void;
}

const SelectType: React.FC<SelectTypeProps> = ({ id, typeId, setType }) => {
    const { iconsList } = useTaskTypesIcons(typeId);

    return (
        <div id={id} style={{ display: 'flex', flexWrap: 'wrap', margin: '10px 0' }}>
            {iconsList.map(type => (
                <SelectItem
                    key={type.id}
                    id={id ? `${id}-${type.id}` : undefined}
                    className={typeId === type.id ? 'active' : ''}
                    onClick={() => setType(Number(type.id))}
                >
                    {type.icon}
                    <Body>{type.text}</Body>
                </SelectItem>
            ))}
        </div>
    );
};

export default SelectType;
